var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "85px",
    height: "85px",
    viewBox: "0 0 85 85",
    enableBackground: "new 0 0 85 85",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M58.339,59.523 l-13.021,4.846l3.771-13.586l16.125-18.279c0.89-1.007,2.756-0.829,4.148,0.393l4.479,3.954c1.392,1.227,1.803,3.058,0.91,4.067 L58.339,59.523z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 58.152,
    y1: 57.928,
    x2: 50.258,
    y2: 50.959
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 49.283,
    y1: 62.686,
    x2: 46.717,
    y2: 60.367
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 54.469,
    y1: 54.533,
    x2: 63.597,
    y2: 44.186
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 61.962,
    y1: 36.614,
    x2: 71.078,
    y2: 44.656
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M41.115,57.486H12.552c-1.526,0-2.775-1.248-2.775-2.775V23.407c0-1.526,1.249-2.775,2.775-2.775h45.196 c1.525,0,2.775,1.249,2.775,2.775v6.105"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 22.845,
    y1: 42.39,
    x2: 11.382,
    y2: 56.109
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 10.766,21.627 35.226,40.509 59.481,21.472  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailme);
export default __webpack_public_path__ + "static/media/emailme.a60657ebd5cb15ed089713db525cda0d.svg";
export { ForwardRef as ReactComponent };